// Single home for the bulk cross-listing platform taxonomy. Every group below answers one
// question about a platform; a platform can (and does) belong to more than one group.
export const ALLOWED_PLATFORMS = ['shopify', 'wooCommerce', 'bigCommerce', 'ebay', 'etsy', 'depop', 'poshmark', 'grailed', 'whatnot', 'offerup', 'vestiaire'];
export const COMPLEX_PLATFORMS = ['ebay', 'etsy', 'poshmark', 'depop', 'grailed', 'whatnot', 'offerup', 'vestiaire'];   // need per-listing category/attribute setup
export const EXTENSION_PLATFORMS = ['poshmark', 'depop', 'grailed', 'whatnot', 'offerup', 'vestiaire'];      // created through the Chrome extension, one account per run
export const SIMPLE_PLATFORMS = ['shopify', 'wooCommerce', 'bigCommerce'];// publish directly, no extra setup
export const DEFAULTS_PLATFORMS = ['ebay', 'etsy'];                       // need shop-level defaults (policies, profiles)

// Most items one run can cover. The server refuses a bigger batch outright, when checking the
// items and again when starting the run, so asking for more can only ever fail.
// Keep in sync with MAX_BULK_CROSS_LISTING_SIZE in server/src/constants/listings-constants.js
export const MAX_BULK_CROSS_LISTING_SIZE = 100;

// Where the app sends people to install the browser extension. Named here because both the
// marketplace step and the run page offer it.
export const EXTENSION_INSTALL_URL =
  'https://chromewebstore.google.com/detail/voolist-%E2%80%93-cross-list-in-o/nakhahocpgjadgcmnlfhohjjegoeockd';

// Platform display names live in one place already — reuse it here instead of
// keeping a second copy that could drift out of sync.
export { getPlatformDisplayName } from 'src/utils/platform-label';
